import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IVerifyUserIdsRepository } from '@/coreInfrastructureModule/interfaces/IVerifyUserIdsRepository';
import { VerifyUserIdsRequest } from '@/coreInfrastructureModule/axios/generated/registerBusinessManage/api';

/**
 * ユーザーID（メール）の存在確認ユースケース
 */
export class VerifyUserIdsUseCase {
  private repository: IVerifyUserIdsRepository;

  /**
   * コンストラクタ
   * @param repository - ユーザー確認Repository
   */
  constructor(repository: IVerifyUserIdsRepository) {
    this.repository = repository;
  }

  /**
   * 存在確認を実行する
   * @param userIds - 確認対象のユーザーID配列（メール）
   */
  public async Execute(userIds: string[]): Promise<INetworkResult<{ existingUserIds: string[]; notFoundUserIds: string[] }, IError>> {
    const request: VerifyUserIdsRequest = { userIds };
    const res = await this.repository.verify(request);
    if (res.status.type === 'error') return { status: { type: 'error', error: res.status.error } };

    const existingUserIds = res.status.data.data.existingUserIds ?? [];
    const notFoundUserIds = res.status.data.data.notFoundUserIds ?? [];
    return { status: { type: 'success', data: { existingUserIds, notFoundUserIds } } };
  }
}
